import type { Stripe } from "@stripe/stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromises: Record<string, Promise<Stripe | null>> = {};
const getStripe = (publishableKey?: string) => {
  const key = publishableKey || import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY!;
  if (!stripePromises[key]) {
    stripePromises[key] = loadStripe(key);
  }
  return stripePromises[key];
};

export default getStripe;
